// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".labelDivWidth[data-v-61887c64] {\n  width: 100px;\n}\n.custom-title[data-v-61887c64] {\n  font-size: 32px;\n  padding: 0;\n}\n.project-count[data-v-61887c64] {\n  margin-top: -16px;\n  color: #010a11;\n  font-family: Outfit, sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n}", ""]);
// Exports
module.exports = exports;
